import { useState, useCallback, useEffect } from "react";
import { useAuth } from "./useAuth";

export const useUsageMetrics = (accountId) => {
  const { apiClient } = useAuth();
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(!!accountId);
  const [error, setError] = useState(null);

  const fetchUsageMetrics = useCallback(async () => {
    if (!accountId) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams({
        start_date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0],
        end_date: new Date().toISOString().split("T")[0],
      });

      const response = await apiClient.get(
        `usage/time-series/${accountId}/?${params}`,
      );

      setMetrics(response.data);
    } catch (err) {
      console.error("Error fetching usage metrics:", err);
      // Don't show error for 404 - means no usage data available
      if (err.response?.status === 404) {
        setMetrics(null);
      } else if (err.response?.status !== 401) {
        setError("Failed to fetch usage metrics");
      }
    } finally {
      setLoading(false);
    }
  }, [apiClient, accountId]);

  // Fetch on mount and when accountId changes
  useEffect(() => {
    fetchUsageMetrics();
  }, [fetchUsageMetrics]);

  // Check if we have metrics data (new API returns an array)
  const hasData = Array.isArray(metrics) && metrics.length > 0;

  return {
    metrics,
    loading,
    error,
    hasData,
    refetch: fetchUsageMetrics,
  };
};
